export const URL_BASE = {};
export const URL_API = {};
export const DETALLE_BANK = {
  bcp:{
    soles: 'S/ 5.00',
    dolares:'$ 1.80'
  },
  scotia:{
    soles: 'S/ 5.00',
    dolares:'$ 1.80'
  },
  bbva:{
    soles: 'S/ 3.00',
    dolares:'$ 1.50'
  },
  visa:{
    soles: '2.59% del monto a debitar',
    dolares:'2.59% del monto a debitar'
  }
}
export const SUSCRIPTION = [
    {
      type: 'BCP',
      viaWeb: [
        { text: '1. Ingresa a la banca por Internet del BCP.'},
        { text: '2. Ingresa a “Pago un servicio”.'},
        { text: '3. En “escribe el nombre de la empresa” coloca “SURA Investments SAF”.'},
        { text: '4. Selecciona el fondo donde deseas invertir.'},
        { text: '5. Ingresa tu Código Único de Cliente (en el caso de los fondos SURA Capital Estratégico, Selección Global I y Bonos Globales, deberás indicar la letra A o B luego del CUC, esto para diferenciar a la serie a la cual deseas suscribir) y luego haz clic en “continuar”.'},
        { text: '6. Indica el monto a invertir y la cuenta a cargar.'},
        { text: '7. Finalmente selecciona “pagar”.'}
      ],
      viaAgencia: [
        { text: '1. Indica que deseas hacer un pago a “SURA Investments SAF” por medio del sistema de Credipago.'},
        { text: '2. Luego coloca el “Fondo” en el cual deseas invertir.'},
        { text: '3. Indica tu Código Único de Cliente (en el caso de los fondos SURA Capital Estratégico, Selección Global I y Bonos Globales, deberás indicar la letra A o B luego del CUC, esto para diferenciar a la serie a la cual deseas suscribir).'},
        { text: '4. Finalmente, solicita el comprobante de tu operación.'}
      ]
    },
    {
      type: 'SCOTIA',
      viaWeb: [
        { text: '1. Ingresa a la nueva banca por internet del Scotiabank.'},
        { text: '2. En la opción “Quiero”, elige “Pagar o recargar” y luego ingresa a “Otras empresas e instituciones”.'},
        { text: '3. Elige la categoría “Otros” y en la lista selecciona “SURA Investments SAF SAC”.'},
        { text: '4. En la lista desplegable de "tipo de servicio" elige el fondo donde deseas invertir.'},
        { text: '5. Indica tu Código Único de Cliente (en el caso de los fondos SURA Capital Estratégico, Selección Global I y Bonos Globales,deberás indicar la letra A o B luego del CUC, esto para diferenciar a la serie a la cual deseas suscribir) y luego haz clic en continuar.'},
        { text: '6. Selecciona el recibo (verifica la información de tu número de documento de identidad).'},
        { text: '7. Coloca check en “Pagar monto parcial” y escribe el monto.'},
        { text: '8. Finalmente, haz clic en pagar, luego elige la cuenta y selecciona "Pagar".'}
      ],
      viaAgencia: [
        { text: '1. Indica que deseas hacer un pago a “SURA Investments SAF” por medio del servicio de recaudación en cuotas variables.'},
        { text: '2. Luego coloca el “Fondo” en el cual deseas invertir.'},
        { text: '3. Indica tu Código Único de Cliente (en el caso de los fondos SURA Capital Estratégico, Selección Global I y Bonos Globales, deberás indicar la letra A o B luego del CUC, esto para diferenciar a la serie a la cual deseas suscribir).'},
        { text: '4. Finalmente, solicita el comprobante de tu operación.'}
      ]
    },
    {
      type: 'BBVA',
      viaWeb: [
        { text: '1. Ingresa a la "Banca por Internet" del BBVA.'},
        { text: '2. Ingresa a "Paga tus Servicios".'},
        { text: '3. Selecciona "Instituciones y Empresas".'},
        { text: '4. Selecciona "Nombre" y coloca “SURA Investments SAF”, luego elige el fondo donde deseas invertir y clic en "siguiente".'},
        { text: '5. Coloca tu Código Único de Cliente (en el caso de los fondos SURA Capital Estratégico, Selección Global I y Bonos Globales, deberás indicar la letra A o B luego del CUC, esto para diferenciar a la serie a la cual deseas suscribir) y clic en "buscar".'},
        { text: '6. Indica el monto a invertir y clic en “siguiente”, luego elija la cuenta a cargar.'},
        { text: '7. Escribe tu contraseña de operaciones.'},
        { text: '8. Finalmente, selecciona "Grabar".'}
      ],
      viaAgencia: [
        { text: '1. Indica que deseas hacer un pago a “SURA Investments SAF” por medio del servicio de recaudación de cuotas variables.'},
        { text: '2. Luego coloca el “Fondo” al cual deseas invertir.'},
        { text: '3. Indica tu Código Único de Cliente (en el caso de los fondos SURA Capital Estratégico, Selección Global I y Bonos Globales, deberás indicar la letra A o B luego del CUC, esto para diferenciar a la serie a la cual deseas suscribir).'},
        { text: '4. Finalmente, solicita el comprobante de tu operación.'}
      ]
    },
    {
      type: 'IBK',
      viaWeb: [
        { text: '1. Ingresa a Banca por internet/ Personas.'},
        { text: '2. Luego selecciona “Paga o recarga”.'},
        { text: '3. Selecciona la categoría “Pago de servicios” y posterior a ello, la opción “Iniciar pago o recarga”.'},
        { text: '4. Registra en empresa “SURA Investments SAF”.'},
        { text: '5. En servicio, elige el fondo a suscribir.'},
        { text: '6. Detalla el COD UNICO CLIEN (CUC) y da click en “Buscar”.'},
        { text: '7. Elige la cuenta de cargo, el monto y valida los datos.'},
        { text: '8. Finalmente selecciona “Confirmar”.'}
      ],
      viaAgencia: [
        
      ]
    }
  ];
export const SUSCRIPTION_JURIDICO = [
    {
      type: 'BCP',
      viaWeb: [
        { text: '1. Ingresa a la banca por Internet del BCP(Telecrédito).'},
        { text: '2. Elije a “opciones monetarias”.'},
        { text: '3. Luego, selecciona "Pagos varios" y clic en la opción "Pago de servicios".'},
        { text: '4. En "Busque la empresa a pagar" coloque SURA Investments SAF y clic en buscar.'},
        { text: '5. En la lista de servicio selecciona el "Fondo" en el que desea invertir y clic en continuar.'},
        { text: '6. Ingresa tu Código Único de Cliente (en el caso de los fondos SURA Capital Estratégico, Selección Global I y Bonos Globales, deberás indicar la letra A o B luego del CUC, esto para diferenciar a la serie a la cual deseas suscribir) y luego haz clic en “continuar”.'},
        { text: '7. Selecciona la cuenta a cargar.'},
        { text: '8. Proceda a firmar la operaciones.'},
        { text: '9. Finalmente, apruebe la operación.'}
        
      ],
      viaAgencia: [
        { text: '1. Indica que deseas hacer un pago a “SURA Investments SAF” por medio del sistema de Credipago.'},
        { text: '2. Luego coloca el “Fondo” en el cual deseas invertir.'},
        { text: '3. Indica tu Código Único de Cliente (en el caso de los fondos SURA Capital Estratégico, Selección Global I y Bonos Globales, deberás indicar la letra A o B luego del CUC, esto para diferenciar a la serie a la cual deseas suscribir).'},
        { text: '4. Finalmente, solicita el comprobante de tu operación.'}
      ]
    },
    {
      type: 'SCOTIA',
      viaWeb: [
        { text: '1. Ingresa a la nueva banca por internet del Scotiabank(Telebanking).'},
        { text: '2. Selecciona la empresa.'},
        { text: '3. Ingresa a "operaciones".'},
        { text: '4. Luego selecciona pagos y clic en "Servicios".'},
        { text: '5. En "Pago de servicios: Preparación de Orden" elije la moneda del abono.'},
        { text: '6. El telebanking asignará un número de orden y clic en "adicionar servicio".'},        
        { text: '7. En "Adicionar Servicio" coloca en la opción de "Empresas e Instituciones" SURA Investments SAF.'},
        { text: '8. Elije el fondo donde vas a invertir.'},
        { text: '9. Indica tu Código Único de Cliente (en el caso de los fondos SURA Capital Estratégico, Selección Global I y Bonos Globales,deberás indicar la letra A o B luego del CUC, esto para diferenciar a la serie a la cual deseas suscribir).'},
        { text: '10. Clic en "pagar" o "pagar y guardar" segun prefieras.'},
        { text: '11. Selecciona el servicio a pagar, coloca el monto, referencia, cuenta de cargo y clic en "programar orden".'},
        { text: '12. Selecciona la orden y clic en "Enviar órdenes seleccionadas".'},
        { text: '13. Finalmente, firmar la operación.'}
      ],
      viaAgencia: [
        { text: '1. Indica que deseas hacer un pago a “SURA Investments SAF” por medio del servicio de recaudación en cuotas variables.'},
        { text: '2. Luego coloca el “Fondo” en el cual deseas invertir.'},
        { text: '3. Indica tu Código Único de Cliente (en el caso de los fondos SURA Capital Estratégico, Selección Global I y Bonos Globales, deberás indicar la letra A o B luego del CUC, esto para diferenciar a la serie a la cual deseas suscribir).'},
        { text: '4. Finalmente, solicita el comprobante de tu operación.'}
      ]
    },
    {
      type: 'BBVA',
      viaWeb: [
        { text: '1. Ingresa a la "Banca por Internet" del BBVA(NetCash).'},
        { text: '2. Ingresa a "Pagos".'},
        { text: '3. Selecciona "Pagos varios".'},
        { text: '4. Luego "Pagos a instituciones".'},
        { text: '5. Coloca "SURA Investments SAF" en Directorio de Instituciones y darle clic en "Buscar".'},
        { text: '6. En nombre de institución selecciona el "Fondo" en el que desea invertir.'},
        { text: '7. Ingresa el Código Único de Cliente y darle clic en "continuar".'},
        { text: '8. Selecciona "Documentos Pendiente de Pago".'},
        { text: '9. Indica el monto a invertar y la cuenta a cargar. Clic en "Continuar".'},
        { text: '10. Verifica los datos ingresados, enviar a "pendiente" y aprobar la operación.'}        
      ],
      viaAgencia: [
        { text: '1. Indica que deseas hacer un pago a “SURA Investments SAF” por medio del servicio de recaudación de cuotas variables.'},
        { text: '2. Luego coloca el “Fondo” al cual deseas invertir.'},
        { text: '3. Indica tu Código Único de Cliente (en el caso de los fondos SURA Capital Estratégico, Selección Global I y Bonos Globales, deberás indicar la letra A o B luego del CUC, esto para diferenciar a la serie a la cual deseas suscribir).'},
        { text: '4. Finalmente, solicita el comprobante de tu operación.'}
      ]
    },
    {
      type: 'IBK',
      viaWeb: [
        { text: '1. Ingresa a Banca por internet/ Empresas.'},
        { text: '2. Luego selecciona “Paga y transferencias.'},
        { text: '3. Selecciona la categoría “Pagos” y posterior a ello, la opción “De servicios”.'},
        { text: '4. En datos de servicio, colaca "SURA Investments SAF" y selecciona el fondo donde se abonará.'},
        { text: '5. Detalla el COD UNICO CLIEN (CUC) y selecciona la cuenta de cargo.'},
        { text: '6. Selecciona agregar y se generará la parte inferior los detalles del abono'},        
        { text: '7. Verifica que todo este conforme y clic en el check del Numero de documento.'},
        { text: '8. Ingrese el monto a abonar.'},
        { text: '9. Por último, verificar los datos y finalizar con el ingreso del token.'}        
      ],
      viaAgencia: [
       
      ]
    }
  ];
export const FORMAT_DATE = 'DD-MM-YYYY';
export const FORMAT_DATE_2 = 'YYYY-MM-DD';
export const FORMAT_DATE_MAX = 'yyyy/MM/DD HH:mm:ss';
export const MY_DATE_FORMATS = {
    parse: {
      dateInput: 'DD-MM-YYYY',
    },
    display: {
      dateInput: 'DD-MM-YYYY',
      monthYearLabel: 'MMM YYYY',
      dateA11yLabel: 'MMM',
      monthYearA11yLabel: 'MMMM YYYY',
    },
};

export const PERMISSIONUSER = ['rescates','cancelrescates','suscripcion','traspaso','transferencias'];
export const optionsMonth = [
  {
    name: 'Enero',
    code: '01'
  },
  {
    name: 'Febrero',
    code: '02'
  },
  {
    name: 'Marzo',
    code: '03'
  },
  {
    name: 'Abril',
    code: '04'
  },
  {
    name: 'Mayo',
    code: '05'
  },
  {
    name: 'Junio',
    code: '06'
  },
  {
    name: 'Julio',
    code: '07'
  },
  {
    name: 'Agosto',
    code: '08'
  },
  {
    name: 'Septiembre',
    code: '09'
  },
  {
    name: 'Octubre',
    code: '10'
  },
  {
    name: 'Noviembre',
    code: '11'
  },
  {
    name: 'Diciembre',
    code: '12'
  }
];

export const CODE_NOTIFICATION = 'NOTIFICACION_RESCATE';

export const BACKSPACE = 'Backspace';
export const ADDRESSEE = {
    YES:'S',
    NOT:'N'
};
export const LANGUAGE = {
  ESP:'0',
  ENG:'1'
};
